import { render, staticRenderFns } from "./IndexOld.vue?vue&type=template&id=f95badfa&"
import script from "./IndexOld.vue?vue&type=script&lang=ts&"
export * from "./IndexOld.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports